exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-container[data-v-6d5bc003]{white-space:nowrap;position:relative;overflow:hidden;width:100%;background-color:white}.scroll-container[data-v-6d5bc003] .el-scrollbar__bar{bottom:0px}.scroll-container[data-v-6d5bc003] .el-scrollbar__wrap{height:49px}\n", ""]);

// exports
